import React from 'react';
import FooterTools from './FooterTools';
import FooterLinks from './FooterLinks';

const Footer = ({ location }) => (
    <div>
        { location.pathname === "/"
            ? <FooterTools/>
            : null
        }
        <FooterLinks/>
    </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/partials/Footer.js